import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import { CompetenceProvider } from "../../../shared/providers/enums/billing-letter/competence-provider";
import { PurchaseOrderService } from '../../../services/purchaseOrder.service';
import { ProductService } from '../../../services/product.service';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { UserService } from '../../../services/user.service';
import { CompaniesService } from '../../../services/companies.service';
import { ConsultantService } from '../../../services/consultant.service';
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { PurchaseOrder } from '../../../models/PurchaseOrder.model';
import { Approver } from '../../../models/Approver.model';
import { Responsible } from '../../../models/Responsible.model';
import { Company } from '../../../models/Company.model';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { DropDownList } from '../../../models/DropDownList.model';
import * as _ from 'lodash';

@Component({
    selector: 'app-purchase-order-hierarchy',
    templateUrl: './purchase-order-hierarchy.component.html',
    styleUrls: ['./purchase-order-hierarchy.component.css']
})
export class PurchaseOrderHierarchyComponent implements OnInit {
    @ViewChild("buttonModalHierarchy") buttonModalHierarchy: ElementRef;
    @ViewChild("closeModal") closeModal: ElementRef;
    loading: boolean;
    loggedUser;
    commonHelper: CommonHelper = new CommonHelper();
    users: Responsible[] = new Array<Responsible>();
    valueAux: number = 0;
    userAux = {
        _id: '',
        name: '',
        maxValue: 0
    };
    managerApprovalValue: number = 0;
    purchaseOrderHierarchy = {
        _id: '',
        manager: {},
        hierarchy: []
    }


    constructor(
        private localStorage: LocalStorage,
        private router: Router,
        public toastr: ToastsManager,
        public userService: UserService,
        public purchaseOrderService: PurchaseOrderService
    ) { }

    async ngOnInit() {
        this.loading = true;
        this.loggedUser = this.localStorage.retrieve('user');
        this.users = await this.userService.getUsersByType([
            'governance', 'commercial', 'administrative', 'finances', 'bills-receive', 'dp', 'manager', 'people'
        ]);

        const purchaseOrderHierarchy = await this.purchaseOrderService.getPurchaseOrderHierarchy(this.loggedUser.username);
        if(purchaseOrderHierarchy) {
            this.purchaseOrderHierarchy = purchaseOrderHierarchy;
            if(this.purchaseOrderHierarchy.hierarchy && this.purchaseOrderHierarchy.hierarchy.length > 0) {
                this.managerApprovalValue = this.purchaseOrderHierarchy.hierarchy[this.purchaseOrderHierarchy.hierarchy.length-1].maxValue;
            }
        } else {
            this.purchaseOrderHierarchy.manager = {
                name: this.loggedUser.name,
                email: this.loggedUser.username,
                division: this.loggedUser.division
            }
        }
        this.loading = false;
    }

    async OnSave() {
        try {
            this.loading = true;
            let response = await this.purchaseOrderService.savePurchaseOrderHierarchy(this.purchaseOrderHierarchy);
            if(response._id)
                this.toastr.success('Alçada salva com sucesso');
            else
                this.toastr.warning('Erro ao salvar alçada');
            this.loading = false;
            this.router.navigate(['/purchase-orders']);
        } catch(err) {
            this.loading = false;
            this.toastr.warning('Erro ao salvar alçada');
            console.log(err);
        }
    }

    OnClear(){
        this.userAux = { _id: '', name: '', maxValue: 0 };
    }

    addUserHierarchy() {
        if(this.purchaseOrderHierarchy.hierarchy.length > 0){
            const existUser = this.purchaseOrderHierarchy.hierarchy.find(u => u._id == this.userAux._id);
            if(existUser) {
                this.toastr.warning('Esta alçada não pode ser adicionada. Aprovador já existe na listagem de alçada', 'Operação inválida'); return;
            }
            const existApproverWithValue = this.purchaseOrderHierarchy.hierarchy.find(h => h.maxValue == this.userAux.maxValue);
            if(existApproverWithValue) {
                this.toastr.warning('Esta alçada não pode ser adicionada, valor de aprovação já existe na listagem de alçada', 'Operação inválida'); return;
            }
        }

        const user = this.users.find(u => u._id === this.userAux._id);
        this.purchaseOrderHierarchy.hierarchy.push({
            _id: user._id,
            name: user.name,
            maxValue: this.userAux.maxValue
        });

        this.sortHierarchy();
        this.userAux = { _id: '', name: '', maxValue: 0 };
        this.managerApprovalValue = this.purchaseOrderHierarchy.hierarchy[this.purchaseOrderHierarchy.hierarchy.length-1].maxValue;
        this.closeModal.nativeElement.click();
    }

    removeUserHierarchy(i) {
        this.purchaseOrderHierarchy.hierarchy.splice(i, 1);
        this.sortHierarchy();
    }

    openModalEditApprover(i, user: any) {
        this.removeUserHierarchy(i);
        this.userAux = { ...user };
        this.buttonModalHierarchy.nativeElement.click();
    }

    sortHierarchy() {
        this.purchaseOrderHierarchy.hierarchy.sort((a, b) => {
            if(a.maxValue < b.maxValue) return -1;
            if(a.maxValue > b.maxValue) return 1;
            return 0;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/views/purchase-order/purchase-order-hierarchy/purchase-order-hierarchy.component.ts